export default {
  header: 'Ingredienser',
  total: 'Totalt',
};
